// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21.5 2H2.5V22H21.5V2ZM17 7V9H7V7H17ZM17 11V13H7V11H17ZM14 17H7V15H14V17Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-article-filled')
export default class ArticleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'article-filled',
    }
  }
}
